import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import _, { cloneDeep } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import FormHeader from "../../../pages/Form/FormHeader";
import FlowBuilder from "../../LogicBuilder/FlowBuilder";
import FlowBuilderSidebar from "../../LogicBuilder/FlowBuilderSidebar";

import { Divider, IconButton } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { ThemeProvider } from "@mui/styles";
import { useEdgesState, useNodesState } from "reactflow";
import { CustomButton, LogicCancelButton, LogicSaveButton } from "../../Custom/Buttons";
import {
  RedirectIndex,
  generateKeyList,
} from "./logicUtils";
import { LogicsSettingsDialogProps } from "./type";
import { getStandardDialogTheme } from "./utils";

import {
  HeaderContainer,
  LogicTabBodyContainer,
  LogicTabContentContainer,
  LogicTabHeaderContainer,
  LogicTabRootContainer,
  LogicTabSidebarActions,
  LogicTabSidebarContainer,
  LogicTabSidebarContent,
  LogicTabSidebarHeader,
  PopupCloseIconComponent,
} from "./styled";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function LogicsSettingsDialog({
  open,
  closeHandler,
  allQuestionFormData,
  setQuestionFormData,
  setAllValues,
  setSelectedData,
}: LogicsSettingsDialogProps) {
  const [expand, setExpand] = useState(false);
  const [selectedNodeId, setSelectedNodeId] = useState<any>("");
  const [goToIndex, setGoToIndex] = useState<any>(null);
  const [formDirty, setFormDirty] = useState<boolean>(false);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [newQuestionData, setNewQuestionData] = useState<any>([]);
  const [selestedQuestionNo, setSelectedQuestionNo] = useState<number>();
  const [nextSelectedIndex, setNextSelectedIndex] = useState<any>(null);

  const cleanUp = () => {
    setExpand(false);
    setGoToIndex(null);
    setSelectedNodeId("");
    setNextSelectedIndex(null);
  };

  useEffect(() => {
    cleanUp();
  }, [open]);

  const sortedAllQuestionFormData = useMemo(() => {
    setNewQuestionData(allQuestionFormData);

    return allQuestionFormData;
  }, [allQuestionFormData]);

  const selectedNodeData = useMemo(() => {
    return nodes.find((node: any) => {
      if (node.customNodeIndex === selectedNodeId) {
        return true;
      }
      return false;
    }) || null;
  }, [nodes, selectedNodeId]);

  useEffect(() => {
    if (!formDirty && selectedNodeId !== "") {
      const redirectIndex = RedirectIndex(
        Number(selectedNodeId),
        allQuestionFormData
      );

      const gotoIndex =
        redirectIndex === "noConnection"
          ? "noConnection"
          : Array.isArray(redirectIndex)
            ? redirectIndex
            : [];

      setGoToIndex(gotoIndex);
      setNextSelectedIndex(gotoIndex);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allQuestionFormData, selectedNodeId]);

  useEffect(() => {
    const node: any = nodes.find((node: any) => node.customNodeIndex === selectedNodeId);
    if (node) {
      setSelectedQuestionNo(node.customNodeIndex + 1);
    }
  }, [nodes, selectedNodeId]);


  const expandSidebar = () => {
    setExpand(true);
  };

  const collapseSidebar = () => {
    setExpand(false);
  };

  const sidebarCloseHandler = () => {
    collapseSidebar();
    setSelectedNodeId("");
  };

  const cancelHandler = () => {
    collapseSidebar();
    setSelectedNodeId("");
    setFormDirty(false);
    setNewQuestionData(allQuestionFormData);
  };

  const isArraysOfObjectsEqual = (arr1: any, arr2: any) => {
    if (!(_.isEmpty(goToIndex) && _.isEmpty(nextSelectedIndex))) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        const dependedkeyList = generateKeyList(newQuestionData, true);
        if (!_.isEqual(arr1[i], arr2[i])) {
          if (
            dependedkeyList.includes(arr1[i].nextIndex) &&
            newQuestionData[arr1[i].nextIndex]?.dependedId !== ""
          ) {
            return true;
          }
        }
      }
      return false;
    }
  };

  const removeDependency = () => {
    if (selectedNodeId) {
      const nodeClone = cloneDeep(nodes)
      const selectedNodeData: any = nodeClone[Number(selectedNodeId)]
      selectedNodeData["questionData"]["dependedId"] = ""
      const filteredEdge = edges.filter((edge) => {
        return edge?.source !== selectedNodeData?.questionData?.name && edge?.target !== selectedNodeData?.questionData?.name
      })
      nodeClone[Number(selectedNodeId)] = selectedNodeData
      const newQuestionDataClone = cloneDeep(newQuestionData)
      newQuestionDataClone[Number(selectedNodeId)]["dependedId"] = ""
      newQuestionDataClone[Number(selectedNodeId)]["isDepended"] = false
      setEdges(filteredEdge)
      setNodes(nodeClone)
    }
  }

  const getDisabledStatus = () => {
    if (formDirty) {
      return !formDirty;
    } else {
      return isArraysOfObjectsEqual(goToIndex, nextSelectedIndex);
    }
  };

  const saveHandler = (fromPopup?: boolean) => {
    const clonedData = cloneDeep(newQuestionData);

    // const selectedNodeDetails = clonedData[selectedNodeId];
    // const dependedId = selectedNodeDetails && selectedNodeDetails?.dependedId;
    // const { redirectNondependentIndexList, redirectDependentIndexList } =
    //   generateRedirectFlowList(clonedData);

    // const nondependedKeyList = Object.keys(redirectNondependentIndexList).map(
    //   (data) => Number(data)
    // );

    // if (!_.isEmpty(goToIndex)) {
    // goToIndex?.forEach((goto: any, index: number) => {
    // if (
    //   goto.nextIndex === "end" &&
    //   nextSelectedIndex[index].nextIndex !== goto.nextIndex
    // ) {

    //future use
    // let startIndex: any;
    // const nonDependedkeyList = generateKeyList(clonedData, false);
    // const dependedkeyList = generateKeyList(clonedData, true);
    // if (!nonDependedkeyList.includes(Number(selectedNodeId))) {
    //   startIndex = getParentIndex(
    //     redirectNondependentIndexList,
    //     redirectDependentIndexList,
    //     Number(selectedNodeId),
    //     dependedkeyList
    //   );
    // } else {
    //   startIndex = Number(selectedNodeId);
    // }

    // clonedData.forEach((question: any, index: number) => {
    //   if (index > startIndex && nondependedKeyList.includes(index)) {
    //     clonedData[index].isDepended = true;
    //     const currentIndexOptionId = generateLabelList(clonedData[index]);
    //     if (!_.isEmpty(currentIndexOptionId)) {
    //       for (const key in currentIndexOptionId) {
    //         clonedData.forEach((ques: any, index: number) => {
    //           if (
    //             Array.isArray(ques.dependedId) &&
    //             ques.dependedId.includes(key)
    //           ) {
    //             const updatedId = ques.dependedId.filter((id: string) => {
    //               return id !== key;
    //             });
    //             if (updatedId.length > 1) {
    //               ques.dependedId = updatedId;
    //             } else {
    //               ques.dependedId = updatedId[0];
    //             }
    //           } else if (ques.dependedId === key) {
    //             ques.dependedId = "";
    //           }
    //         });
    //       }
    //     }
    //   }
    // });
    // } else {
    // if (
    //   nextSelectedIndex[index].nextIndex !== goto.nextIndex &&
    //   dependedId === ""
    // ) {
    //   if (clonedData[goto.nextIndex].isDepended)
    //     clonedData[goto.nextIndex].isDepended = false;
    //   // const [removed] = clonedData.splice(goto.nextIndex, 1);
    //   // if (nextSelectedIndex[index].nextIndex === "end")
    //     // clonedData.splice(Number(selectedNodeId) + 1, 0, removed);
    //   // else
    //     // clonedData.splice(nextSelectedIndex[index].nextIndex, 0, removed);
    // } else if (goto.nextIndex !== nextSelectedIndex[index].nextIndex) {
    //   if (nextSelectedIndex[index].nextIndex === "end") {
    //     // const [removed] = clonedData.splice(goto.nextIndex, 1);
    //     // clonedData.splice(Number(selectedNodeId) + 1, 0, removed);
    //   } else {
    //     clonedData[goto.nextIndex].dependedId = dependedId;
    //     // const [removed] = clonedData.splice(goto.nextIndex, 1);
    //     // clonedData.splice(nextSelectedIndex[index].nextIndex, 0, removed);
    //   }
    // } else 
    // if (goto.optionName === "All other cases") {
    // if (["dropdown", "multi-select", "select", "image-multi-select", "image-select"].includes(clonedData[selectedNodeId]?.type)) {
    //   const selectedDependedIds = clonedData[selectedNodeId]?.options?.map((option: any) => option?.id || "");

    //   const availableDependedIds = clonedData
    //     .filter((data: any) => {
    //       if (Array.isArray(data.dependedId)) {
    //         return data.dependedId.some((element: any) => selectedDependedIds.includes(element));
    //       } else {
    //         return selectedDependedIds.includes(data.dependedId);
    //       }
    //     })
    //     .map((data: any) => data.dependedId);
    //   if (availableDependedIds?.[0]?.length) {
    //     const filteredDependedIds = selectedDependedIds.filter((dependedId: any) => !availableDependedIds[0].includes(dependedId))
    //     clonedData.forEach((data: any, index: number) => {
    //       if ((!data.dependedId || !data.dependedId.length) && index !== selectedNodeId) {
    //         data.dependedId = filteredDependedIds
    //         data['isDepended'] = true
    //       }
    //     })
    //   }
    // }
    // }
    // }
    // });
    // }

    const newDataFormSettings = Array.from(clonedData);

    setAllValues(newDataFormSettings);
    setQuestionFormData(newDataFormSettings);
    setFormDirty(false);

    if (!fromPopup) {
      cleanUp();
    }
  };

  return (
    <ThemeProvider theme={getStandardDialogTheme(true)}>
      <Dialog
        fullScreen
        open={open}
        onClose={closeHandler}
        TransitionComponent={Transition}
      >
        <LogicTabRootContainer>
          <LogicTabHeaderContainer>
            <FormHeader type="logic" />
            <Divider />
          </LogicTabHeaderContainer>
          <LogicTabBodyContainer>
            {expand && (
              <LogicTabSidebarContainer isExpanded={expand}>
                <LogicTabSidebarHeader>
                  <HeaderContainer>
                    {`Edit Logic for ${selestedQuestionNo}`}
                    <IconButton onClick={sidebarCloseHandler}>
                      <PopupCloseIconComponent />
                    </IconButton>
                  </HeaderContainer>
                </LogicTabSidebarHeader>
                <Divider />
                <LogicTabSidebarContent>
                  <FlowBuilderSidebar
                    nodes={nodes}
                    goToIndex={goToIndex}
                    setGoToIndex={setGoToIndex}
                    selectedNodeId={selectedNodeId}
                    selectedNodeData={selectedNodeData}
                    allQuestionFormData={sortedAllQuestionFormData ?? []}
                    setFormDirty={setFormDirty}
                    setNewQuestionData={setNewQuestionData}
                    newQuestionData={newQuestionData}
                    nextSelectedIndex={nextSelectedIndex}
                  />
                </LogicTabSidebarContent>
                <LogicTabSidebarActions>
                  <CustomButton text="Remove Logic" onClick={removeDependency} />
                  <LogicCancelButton onClick={cancelHandler} />
                  <LogicSaveButton
                    disabled={getDisabledStatus()}
                    onClick={() => saveHandler(false)}
                  />
                </LogicTabSidebarActions>
              </LogicTabSidebarContainer>
            )}
            <LogicTabContentContainer isExpanded={expand}>
              <FlowBuilder
                nodes={nodes}
                edges={edges}
                setNodes={setNodes}
                setEdges={setEdges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                setSelectedNodeId={setSelectedNodeId}
                expandSidebar={expandSidebar}
                allQuestionFormData={sortedAllQuestionFormData}
                saveHandler={saveHandler}
                formDirty={formDirty}
                setFormDirty={setFormDirty}
                selectedNodeId={selectedNodeId}
                setNewQuestionData={setNewQuestionData}
                setQuestionFormData={setQuestionFormData}
              />
            </LogicTabContentContainer>
          </LogicTabBodyContainer>
        </LogicTabRootContainer>
      </Dialog>
    </ThemeProvider>
  );
}
